<template>
  <el-header>
    <div class="left_area flex-1">
      <!-- logo+标题 -->
      <i class="logo_title"></i>
      <!-- 顶部菜单 -->
      <ul class="tabType clearfix">
        <li v-for="(item,index) in navBar.textArr"
            @click="changeNav(item, index)"
            :class="{on:navBar.nowIndex==index}"
        >
          <i :class="item.icon"></i>
          <span class="boxs">{{item.name}}</span>
        </li>
      </ul>
    </div>
    <!-- 右边头像区域 -->
    <el-dropdown class="user_q" @command="userQuit" trigger="click">
      <el-button size="medium" type="info">
        <img :src="'data:image/jpeg;base64,' + head_pic" alt="" class="headImg boxs" v-if="head_pic">
        <img src="@/assets/images/layout/head.png" alt="" class="headImg boxs" v-else>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="userName">{{userName}}</el-dropdown-item>
        <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-header>
</template>

<script>
  // import {getTokenUserInfo} from '@/utils/auth'

  export default {
    name: 'theHead',
    data() {
      return {
        userName: '18787878787', // 用户登录账号
        head_pic: '', //用户头像url
        // 头部导航栏
        navBar: {
          textArr: [
            {
              name: '资源',
              icon: 'resource',
              value: 'resource'
            },
            {
              name: '运营',
              icon: 'operate',
              value: 'operate'
            },
            {
              name: '财务',
              icon: 'finance',
              value: 'finance'
            },
            {
              name: '系统',
              icon: 'system',
              value: 'system'
            },
            {
              name: '优享',
              icon: 'enjoy',
              value: 'enjoy'
            },
          ],
          nowIndex: 0
        },
      }
    },
    components: {},
    computed: {},
    methods: {
      // 切换导航一级菜单
      changeNav(item, idx) {
        // console.log('changeNav-item:', item);
        this.navBar.nowIndex = idx
        // 把当前选中的导航菜单传递给父组件
        this.$emit('changeNav', item);
      },
      // 退出登录
      userQuit(command) {
        if (command == 'userName') {
          console.log('command', command)
          return
        }
        if (command == 'logOut') {
        }
        this.$confirm('退出当前登录账号?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('user/userLogout')
              .then(resp => {
                window.location.href = process.env.VUE_APP_SECRET_LOGIN_URL
              })
              .catch(err => {
                console.log(err)
              })
        }).catch(() => {

        })
      }
    },
    created() {
      // 当前用户名称
      this.userInfo = this.$store.getters['user/getUserInfo'];
      console.log(this.userInfo)
      this.navBar.textArr = this.userInfo.menus
      this.userName = this.$store.getters['user/getUserInfo'].name

      // 把当前选中的导航菜单(初始选中第一个)传递给父组件
      this.$nextTick(() => {
        this.$emit('changeNav', this.navBar.textArr[0]);
      })

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .flex-1 {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}
  .el-header {
    // 固定header在页面上方
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    z-index: 999;
    height: 44px !important;
    line-height: 44px;
    background: #FA6241;
    box-shadow: 0px 4px 0px #EC502E;
    -moz-box-shadow: 0px 4px 0px #EC502E;
    -webkit-box-shadow: 0px 4px 0px #EC502E;

    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    // min-width: 913px;
    // min-width: 850px;
    min-width: 830px;
    padding: 0;
  }


  .el-header .left_area {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    // min-width: 756px;
  }

  .el-header .left_area .logo_title {
    width: 180px;
    height: 44px;
    background: url('../../../assets/images/layout/logo_title.png') no-repeat;
    background-size: 100% 100%;
  }

  // 导航栏
  .el-header .left_area .tabType {
    height: 44px;
    max-width: calc( 100% - 180px );
    overflow: hidden;
    // min-width: 576px;
    line-height: 44px;
    text-align: center;
  }

  .tabType li {
    float: left;
    width: 72px;
    color: #FFFFFF;
    font-size: 12px;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    transition: width 0.4s, height 0.2s, background 0.4s, transform 0.4s;
    -moz-transition: width 0.4s, height 0.2s, background 0.4s, transform 0.4s;
    -webkit-transition: width 0.4s, height 0.2s, background 0.4s, transform 0.4s;
    -o-transition: width 0.4s, height 0.2s, line-height 0.2s, background 0.4s, -o-transform 0.4s;

  }

  .tabType li:after {
    content: '';
    position: absolute;
    width: 72px;
    height: 4px;
    background: #EC502E;
    bottom: -4px;
    left: 0;
    transition: width 0.4s, height 0.2s, background 0.4s, transform 0.4s;
    -moz-transition: width 0.4s, height 0.2s, background 0.4s, transform 0.4s;
    -webkit-transition: width 0.4s, height 0.2s, background 0.4s, transform 0.4s;
    -o-transition: width 0.4s, height 0.2s, line-height 0.2s, background 0.4s, -o-transform 0.4s;
  }

  .tabType li:hover,
  .tabType li.on {
    color: #FA6241;
    background: #ffffff;
  }

  .tabType li:hover:after,
  .tabType li.on:after {
    background: #F1F1F1;
  }

  .tabType li i {
    width: 16px;
    height: 16px;
    margin-right: 2px;
  }

  .tabType li span {
    height: 44px;
    padding: 1px 0 0 0;
  }

  // 图标-首页
  .tabType li i.home {
    background: url('../../../assets/images/layout/header/home.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.home,
  .tabType li.on i.home {
    background: url('../../../assets/images/layout/header/home_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-订单
  .tabType li i.order {
    background: url('../../../assets/images/layout/header/order.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.order,
  .tabType li.on i.order {
    background: url('../../../assets/images/layout/header/order_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-资源
  .tabType li i.resource {
    background: url('../../../assets/images/layout/header/resource.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.resource,
  .tabType li.on i.resource {
    background: url('../../../assets/images/layout/header/resource_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-运营
  .tabType li i.operate {
    background: url('../../../assets/images/layout/header/operate.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.operate,
  .tabType li.on i.operate {
    background: url('../../../assets/images/layout/header/operate_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-财务
  .tabType li i.finance {
    background: url('../../../assets/images/layout/header/finance.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.finance,
  .tabType li.on i.finance {
    background: url('../../../assets/images/layout/header/finance_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-接口
  .tabType li i.interface {
    background: url('../../../assets/images/layout/header/interface.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.interface,
  .tabType li.on i.interface {
    background: url('../../../assets/images/layout/header/interface_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-系统
  .tabType li i.system {
    background: url('../../../assets/images/layout/header/system.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.system,
  .tabType li.on i.system {
    background: url('../../../assets/images/layout/header/system_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-会员
  .tabType li i.member {
    background: url('../../../assets/images/layout/header/member.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.member,
  .tabType li.on i.member {
    background: url('../../../assets/images/layout/header/member_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-商城
  .tabType li i.mall {
    background: url('../../../assets/images/layout/header/mall.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.mall,
  .tabType li.on i.mall {
    background: url('../../../assets/images/layout/header/mall_on.png') no-repeat;
    background-size: 100% 100%;
  }


  // 图标-设备管理
  .tabType li i.deviceManage {
    background: url('../../../assets/images/layout/sider/deviceManage.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.deviceManage,
  .tabType li.on i.deviceManage {
    background: url('../../../assets/images/layout/sider/deviceManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-优享
  .tabType li i.enjoy {
    background: url('../../../assets/images/layout/header/enjoy.png') no-repeat;
    background-size: 100% 100%;
  }

  .tabType li:hover i.enjoy,
  .tabType li.on i.enjoy {
    background: url('../../../assets/images/layout/header/enjoy_on.png') no-repeat;
    background-size: 100% 100%;
  }

  // 右边头像
  .el-header .user_q {
    position: absolute;
    right: 0px;
    border: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    button {
      background: none;
      // background-color: #303133;
      border: none;
      padding-left: 0;
      padding-right: 6px;
    }

  }

  // 退出登录框-第一行用户账号
  .el-dropdown-menu .el-dropdown-menu__item:nth-child(1) {
    text-align: center;
    color: #2B2727;
    background-color: #EEEEEE;
  }

  .el-dropdown-menu .el-dropdown-menu__item:nth-child(1):hover {
    // background-color: rgb(196, 195, 195)
  }

  // 退出登录框-第二行退出登录
  .el-dropdown-menu .el-dropdown-menu__item:nth-child(2) {
    text-align: center;
    color: #FA6241;
  }

  .el-header .headImg {
    width: 26px;
    height: 26px;
    background: #f7f7f7;
    background-size: 100% 100%;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border: 2px solid #ffffff;
  }
</style>
